export const SaasMobileFirst = () => {
    return (
        <div className="pt-[54px] flex flex-col px-[53px]  [background:linear-gradient(135deg,rgba(235.51,245.26,255,1)_2.885%,rgba(185,242.42,250,1)_56.731%,rgba(110.34,201.36,255,1)_97.596%)] h-[390px]">
            <div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">全球办公网络SaaS应用加速</div>
            <div className="flex gap-[40px] mt-[11px]">
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/saas/home-1.png"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        企业全球办公网络加速
                    </div>
                </div>
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/saas/home-2.png"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        全球客户建联
                    </div>
                </div>
            </div>

            <div className="flex gap-[40px] mt-[8px]">
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/saas/home-3.png"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        海外推广营销品牌建设
                    </div>
                </div>
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/saas/home-4.png"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        AIGC服务加速
                    </div>
                </div>
            </div>

            <div className="flex gap-[40px] mt-[8px] ">
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/saas/home-5.png"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        全球电商平台加速
                    </div>
                </div>
            </div>

            <div className="flex gap-[10px] mt-[16px]">
                <div className="w-[88px] h-[29.8px] flex flex-row justify-center items-center  rounded-[4px] [box-shadow:0px_2.8px_5.599999904632568px_0px_rgba(0,0,0,0.1)] [background:linear-gradient(135deg,rgba(100,183,255,1)_0%,rgba(137,171,255,1)_53.907%,rgba(185,155,255,1)_100%)]">
                    <div className="text-[12px] font-bold text-white">立即咨询</div>
                </div>
                <div
                    style={{
                        width: '88px',
                        height: '29.8px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '4px',

                        boxSizing: 'border-box',
                        borderRadius: '4px',
                        boxShadow: '0px 2.8px 5.599999904632568px 0px rgba(0, 0, 0, 0.1)',
                        backgroundImage: 'linear-gradient(135deg, rgba(106, 181, 255, 1) 0%, rgba(183, 156, 255, 1) 100%)',
                        WebkitBackgroundClip: 'text', // 兼容webkit内核浏览器
                        backgroundClip: 'text',
                        WebkitTextFillColor: 'transparent', // 兼容webkit内核浏览器

                        fontFamily: 'Alibaba PuHuiTi 2.0',
                        fontSize: '12px',
                        fontWeight: 700,
                        lineHeight: '17px',
                        letterSpacing: '0%',
                        textAlign: 'left'
                    }}
                >
                    申请试用
                </div>
            </div>

            <div className="flex justify-center mt-[14px]">
                <img src="/imgs/saas/home.png" className="w-[246px] h-[163px]" />
            </div>
        </div>
    )
}